import useAppState from './useAppState'
import * as QueryHooks from '../ygdrasil/libs/QueryHooks'

export function useMyFocusRows() {
  const { state } = useAppState()
  const { data = [] } = QueryHooks.useMyFocusRows(state)
  return data.filter((r) => r.userId === state.user._id)
}
